import { dayKeyInZone } from '@/lib/dayKey';
import {
  filterRows,
  UNKNOWN_MATCH_VENUE,
  type MatchRowVM,
  type MatchFilterStatus,
} from './eventMatchesView';
export interface MatchFacets {
  divisionId?: string;
  venueId?: string;
  status?: MatchFilterStatus;
}
/** Search keeps its existing all-day scope; a blank query uses the picked day. */
export function matchScope(
  rows: MatchRowVM[],
  scope: { day: string | null; zone: string; query: string },
): MatchRowVM[] {
  const searched = filterRows(rows, { divisionId: 'all', query: scope.query });
  return scope.query.trim()
    ? searched
    : searched.filter((r) => dayKeyInZone(r.startIso, scope.zone) === scope.day);
}
export function applyMatchFacets(rows: MatchRowVM[], facets: MatchFacets): MatchRowVM[] {
  return filterRows(rows, {
    divisionId: facets.divisionId ?? 'all',
    query: '',
    venueId: facets.venueId,
    status: facets.status,
  });
}
const count = (rows: MatchRowVM[], key: (row: MatchRowVM) => string | null) => {
  const options: Record<string, number> = {};
  for (const row of rows) {
    const id = key(row);
    if (id !== null) options[id] = (options[id] ?? 0) + 1;
  }
  return { all: rows.length, options };
};
/** Counts apply the other facets, so selected and zero-count choices remain intelligible. */
export function matchFacetCounts(rows: MatchRowVM[], facets: MatchFacets) {
  return {
    venue: count(
      applyMatchFacets(rows, { ...facets, venueId: undefined }),
      (r) => r.venueId ?? UNKNOWN_MATCH_VENUE,
    ),
    status: count(applyMatchFacets(rows, { ...facets, status: undefined }), (r) =>
      r.state === 'winnerless' ? 'finished' : r.state,
    ),
    division: count(
      applyMatchFacets(rows, { ...facets, divisionId: undefined }),
      (r) => r.divisionId,
    ),
  };
}
